import React from 'react';
import { motion } from 'framer-motion';
import './ProductSection.css';


const ProductSection = () => {
  const products = [
    {
      id: 1,
      name: 'Conveyor Belt',
      image: 'img/product_img/belt.webp',
      description: 'High-performance conveyor belts for various industries.',
    },
    {
      id: 2,
      name: 'Bearing',
      image: 'img/product_img/bearing.jpg',
      description: 'Durable motor gears for seamless operations.',
    },
    {
      id: 3,
      name: 'Modular Belt',
      image: 'img/product_img/modulator_img.webp',
      description: 'Versatile and efficient VFS systems.',
    },
    {
      id: 4,
      name: 'Conveyor Roller',
      image: 'img/product_img/roller_img.webp',
      description: 'Reliable packing equipment for secure shipping.',
    },
    {
      id: 5,
      name: 'Motor Gear Box',
      image: 'img/product_img/motor_img.webp',
      description: 'Reliable packing equipment for secure shipping.',
    },
    {
      id: 6,
      name: 'Roller Frame',
      image: 'img/product_img/rollerframe.webp',
      description: 'Reliable packing equipment for secure shipping.',
    },
    {
      id: 7,
      name: 'VFD Driver',
      image: 'img/product_img/vfd_img.webp',
      description: 'Reliable packing equipment for secure shipping.',
    },
    {
      id: 8,
      name: 'Sprockets',
      image: 'img/product_img/sprockets_img.webp',
      description: 'Reliable packing equipment for secure shipping.',
    },
  ];

  // Animation Variants
  const containerVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
    hover: { scale: 1.05, transition: { duration: 0.3 } },
  };

  const textVariants = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0, transition: { duration: 1.5 } },
  };

  return (
    <div className='product-section-container'id='product'>
      <h1 className="product-heading services-title">Our Products</h1>
      <motion.div
        className="product-section"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {products.map((product) => (
          <motion.div
            key={product.id}
            className="product-card"
            variants={cardVariants}
            whileHover="hover"
          >
            <img
              src={product.image}
              alt={product.name}
              className="product-image"
            />
            <motion.div
              className="product-name-overlay"
              variants={textVariants}
              initial="initial"
              animate="animate"
            >
              {product.name}
            </motion.div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default ProductSection;
